import _ from "lodash";

import {
  Component,
} from "react";
import {
  withLocation,
} from "CommonCore/router-util";

import {
  EditPanel,
  Spinner,
} from "CommonComponents/bricks";
import store from "CommonState/store";
import antragApi from "Apis/antrag-api";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import apifetch from "CommonCore/apifetch";
import {
  schema,
  validateTarif,
} from "Apis/antrag-tarifdaten-api";
import {
  ROLLEN,
} from "App/constants";
import Confirmation from "CommonComponents/confirmation";

const injects = injectsFromSchema(schema);
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "user")
@antragApi.current
export default class AntragTarifTab extends Component {
  constructor() {
    super();
    this.state = {};
  }

  load = async function(antrag) {
    // Tarifdaten zum Antrag laden
    const result = await apifetch(`/api/shkantrag/tarif/${ antrag.a_id }`);
    this.setState({ tarifdaten: result });
  };

  componentDidMount = () => {
    this.load(this.props.currentAntrag);
  };

  onSave = async entity => {
    const { currentAntrag } = this.props;
    const { tarifdaten } = this.state;

    // validation
    const err = validateTarif(entity, currentAntrag);
    if (err) {
      throw err;
    }

    // PBP-2307 evtl. Einstufung an PBP übertragen
    const oldBvsid = tarifdaten?.atd_bvsid;
    const oldBvgid = tarifdaten?.atd_bvgid;
    if ((oldBvsid !== entity.atd_bvsid && (oldBvsid || entity.atd_bvsid)) || (oldBvgid !== entity.atd_bvgid && (oldBvgid || entity.atd_bvgid))) {
      // Eingruppierung/Einstufung wurde geändert, Bestätigung fordern
      this.setState({ einstufungPopupEntity: entity });
    } else {
      await this.doSave(entity);
    }
  };

  doCancel = () => {
    this.setState({ einstufungPopupEntity: null });
  };

  doSave = async entity => {
    const { currentAntrag } = this.props;

    const method = "POST";
    const newEntity = await apifetch(`/api/shkantrag/tarif/${ currentAntrag.a_id }`, {
      method,
      body: JSON.stringify(entity),
    });

    this.setState({ tarifdaten: newEntity });
    this.setState({ einstufungPopupEntity: null });
  };

  render() {
    const { user, currentAntrag } = this.props;
    const { einstufungPopupEntity, bausteine, tarifdaten } = this.state;
    const istSachbTarif = [ROLLEN.ROLLE_SACHBEARBEITER_TARIF, ROLLEN.ROLLE_SACHGEBIETSLEITUNG].includes(user.ro_id);
    const istAntragsteller = (user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER);

    const localSchema = _.cloneDeep(schema);
    const index = localSchema.table.findIndex(field => field.field == "atd_anschreibentext");
    localSchema.table.splice(index + 1, 0, {
      field: "bausteinwahl",
      display: "Textbaustein Aufgabenübertragung",
      type: "select",
      hideFromDetail: true,
      choices: (bausteine || []).filter(r => r.txt_ist_wiss === tarifdaten.atd_ist_wiss).map(item => ({ value: item.txt_text, label: item.txt_bez })),
    });

    return (this.state.tarifdaten && !istAntragsteller)
? <EditPanel
  editable={istSachbTarif}
  entity={this.state.tarifdaten}
  header={<h4 key='h4'>{schema.displayName}</h4>}
  schema={localSchema}
  onChange={this.onChange}
  onBeginEdit={this.onBeginEdit}
  onSave={this.onSave}
  injects={selectInjects(this.props)}>
  {einstufungPopupEntity && <EinstufungAendernPopup
    entity={einstufungPopupEntity}
    currentAntrag={currentAntrag}
    onCancel={this.doCancel}
    onConfirm={this.doSave}
  />}
</EditPanel>
      : <Spinner />;
  }

  onChange = (change, edits) => {
    if (change.bausteinwahl) {
      // Ein Baustein wurde ausgewählt
      if (!edits.atd_anschreibentext) {
        // Baustein ist erster Text im Feld
        edits.atd_anschreibentext = change.bausteinwahl;
      } else {
        // Baustein mit Newline anhängen
        edits.atd_anschreibentext = edits.atd_anschreibentext + "\n" + change.bausteinwahl;
      }
    }
  };

  onBeginEdit = async(edits, entity) => {
    // Bei Beginn der Bearbeitung Katalog der textbausteine laden
    edits.atd_anschreibentext = entity.atd_anschreibentext;
    try {
      const data = await apifetch(`/api/shkkatalog/textbaustein`);
      this.setState({ bausteine: data.data });
    } catch(err) {

    }
  };
}

class EinstufungAendernPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onCancel } = this.props;
    const { errorMessage, inflight } = this.state;
    return (
      <Confirmation
        header='Einstufung bestätigen'
        action='Einstufung bestätigen'
        actionStyle='danger'
        onCancel={onCancel}
        onConfirm={this.pushToPbp}
        inflight={inflight}
        errorMessage={errorMessage}
      >
        <p>Sind Sie sicher, dass Sie die Eingruppierung/Einstufung ändern möchten?</p>
        <p>Die zugrundeliegende Maßnahme in PBP wird dann automatisch neu berechnet.</p>

      </Confirmation>
    );
  }

  pushToPbp = async() => {
    const { onConfirm, entity, currentAntrag } = this.props;
    this.setState({ inflight: true, errorMessage: null });
    try {
      // Tarif hat immer nur eine MN, darum funktioniert das so. Ansonsten ggf alle MN durchlaufen und posten
      await apifetch("/api/shkexport/pbpmassnahme/einstufung", {
        method: "POST",
        body: { mn_id: currentAntrag.massnahmen[0].m_id, mn_bvsid: entity.atd_bvsid, mn_bvgid: entity.atd_bvgid },
      });
      this.setState({ inflight: false });
      await onConfirm(entity);
    } catch(err) {
      this.setState({
        inflight: false,
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
}
